const WOW = window.wow;

window.initNewsPage = () => {
    const tabs = $('.news-tabs__tab');
    const cards = $('.news-tabs__items');
    const showMoreButtons = $('.news-tabs__button_more_news_wrap');
    let currentViewMode = 'normal';

    const reinitNewsWOW = () => {
        new WOW.WOW({
            boxClass: 'wow-news'
        }).init();
    };

    tabs.on('click', function (event) {
        const tab = $(event.target);
        const cardId = tab.data('target');
        const targetButton = $(`#more-news-button-${cardId}`);

        reinitNewsWOW();

        tabs.removeClass('games-tabs__tab-active');
        cards.removeClass('news-tabs__items-active');
        showMoreButtons.hide();

        $(`#${cardId}`).addClass('news-tabs__items-active');
        tab.addClass('games-tabs__tab-active');
        if (targetButton.prop('disabled') != true) {
            targetButton.parent().show();
        }

        var url = new Domurl;
        url.query.tag = cardId;
        window.history.replaceState('', '', url.toString());
    });

    const displayNormalNewsView = () => {
        $('.news-tabs__header-pc-tab-list').addClass('news-tabs__header-pc-tab-active');
        $('.news-tabs__header-pc-tab-tile').removeClass('news-tabs__header-pc-tab-active');
        $('.news-tabs__item-tile-wrap').removeClass('is_active');
        $('.news-tabs__items-wrap').addClass('is_active');
        $('.news-tabs__divider-2').css('display', 'none');
        currentViewMode = 'normal';
    }

    const displayAlternateNewsView = () => {
        $('.news-tabs__header-pc-tab-tile').addClass('news-tabs__header-pc-tab-active');
        $('.news-tabs__header-pc-tab-list').removeClass('news-tabs__header-pc-tab-active');
        $('.news-tabs__items-wrap').removeClass('is_active');
        $('.news-tabs__divider-2').css('display', 'block');
        $('.news-tabs__item-tile-wrap').addClass('is_active');
        currentViewMode = 'alt';
    };

    $('.news-tabs__header-pc-tab-tile').on('click', function () {
        displayAlternateNewsView();
        reinitNewsWOW();

        var url = new Domurl;
        url.query.view = 'tile';
        window.history.replaceState('', '', url.toString());
    });

    $('.news-tabs__header-pc-tab-list').on('click', function () {
        displayNormalNewsView();
        reinitNewsWOW();

        var url = new Domurl;
        url.query.view = 'list';
        window.history.replaceState('', '', url.toString());
    });

    $(window).resize(function () {
        if (currentViewMode != 'normal' && $(window).width() < 992) {
            displayNormalNewsView();
        }
    });
};
